import { Addendum, AddendumExpandOpts, IAddendum } from '@condo/domain';
import { getClient } from './api-client';

export const fetchAddendum = async (addendumId: number, expand: AddendumExpandOpts): Promise<Addendum> => {
    const { data } = await getClient('basecamp').get<{ addendum: IAddendum }>(`/addenda/${addendumId}`, {
        params: { expand },
    });
    return new Addendum(data.addendum);
};
